/**
 * A Promise to delay a Promise
 * @param timeout number
 * @returns Promise<void>
 */var delay = function delay(timeout) {
  return new Promise(function (_) {
    return setTimeout(_, timeout);
  });
};
export { delay };